var map = {
	"./container": 32,
	"./container/": 32,
	"./container/CopyToClipboardProvider": 182,
	"./container/CopyToClipboardProvider.jsx": 182,
	"./container/FilterTableProvider": 22,
	"./container/FilterTableProvider.jsx": 22,
	"./container/FlashMessage": 389,
	"./container/FlashMessage.jsx": 389,
	"./container/FormPageActions": 20,
	"./container/FormPageActions.jsx": 20,
	"./container/NavigationWrapper": 390,
	"./container/NavigationWrapper.jsx": 390,
	"./container/PolarisFormProvider": 42,
	"./container/PolarisFormProvider.jsx": 42,
	"./container/SidebarWrapper": 549,
	"./container/SidebarWrapper.jsx": 549,
	"./container/TestForm": 391,
	"./container/TestForm.jsx": 391,
	"./container/courier/CourierFormWrapper": 392,
	"./container/courier/CourierFormWrapper.jsx": 392,
	"./container/courier/CourierIndexWrapper": 395,
	"./container/courier/CourierIndexWrapper.jsx": 395,
	"./container/dispatch_control/DispatchControlFormWrapper": 396,
	"./container/dispatch_control/DispatchControlFormWrapper.jsx": 396,
	"./container/dispatch_control/DispatchControlIndex": 397,
	"./container/dispatch_control/DispatchControlIndex.jsx": 397,
	"./container/dispatch_control/DispatchControlShow": 398,
	"./container/dispatch_control/DispatchControlShow.jsx": 398,
	"./container/goods_moved_log/GoodsMovedLogsLookup": 399,
	"./container/goods_moved_log/GoodsMovedLogsLookup.js": 399,
	"./container/goods_moved_log/ReturnedItemsReport": 400,
	"./container/goods_moved_log/ReturnedItemsReport.js": 400,
	"./container/goods_moved_log/ReturnsIndex": 401,
	"./container/goods_moved_log/ReturnsIndex.js": 401,
	"./container/index": 32,
	"./container/index.js": 32,
	"./container/order_supply/OrderSupplyIndex": 402,
	"./container/order_supply/OrderSupplyIndex.jsx": 402,
	"./container/order_supply/OrderSupplyShow": 403,
	"./container/order_supply/OrderSupplyShow.js": 403,
	"./container/product/ProductChangelogList": 404,
	"./container/product/ProductChangelogList.jsx": 404,
	"./container/product/ProductFormWrapper": 221,
	"./container/product/ProductFormWrapper.jsx": 221,
	"./container/product/ProductIndexWrapper": 405,
	"./container/product/ProductIndexWrapper.jsx": 405,
	"./container/product/ProductsInventoryTrail": 406,
	"./container/product/ProductsInventoryTrail.js": 406,
	"./container/product/VariantFormWrapper": 407,
	"./container/product/VariantFormWrapper.jsx": 407,
	"./container/product/VariantGoodsLogsScreen": 408,
	"./container/product/VariantGoodsLogsScreen.js": 408,
	"./container/resource_table/ResourceTableForm": 409,
	"./container/resource_table/ResourceTableForm.js": 409,
	"./container/resource_table/ResourceTableIndex": 410,
	"./container/resource_table/ResourceTableIndex.js": 410,
	"./container/resource_table/TableForm": 192,
	"./container/resource_table/TableForm.js": 192,
	"./container/resource_table/TableRowsForm": 220,
	"./container/resource_table/TableRowsForm.js": 220,
	"./container/sale_report/SaleReportIndex": 411,
	"./container/sale_report/SaleReportIndex.js": 411,
	"./container/sale_report/SaleReportShow": 412,
	"./container/sale_report/SaleReportShow.js": 412,
	"./container/sale_report/SaleReportShowLegacy": 413,
	"./container/sale_report/SaleReportShowLegacy.js": 413,
	"./container/sale_report/components/SaleReportTransactionsHistory": 59,
	"./container/sale_report/components/SaleReportTransactionsHistory.js": 59,
	"./container/sale_report/oldVersions/SaleReportShowVersion2": 550,
	"./container/sale_report/oldVersions/SaleReportShowVersion2.js": 550,
	"./container/sale_report/oldVersions/SaleReportTransfersBrief": 195,
	"./container/sale_report/oldVersions/SaleReportTransfersBrief.js": 195,
	"./container/section/SectionBannersForm": 414,
	"./container/section/SectionBannersForm.js": 414,
	"./container/section/SectionIndex": 415,
	"./container/section/SectionIndex.js": 415,
	"./container/section/SectionLinksForm": 416,
	"./container/section/SectionLinksForm.js": 416,
	"./container/seller_application_form/SellerApplicationFormIndex": 417,
	"./container/seller_application_form/SellerApplicationFormIndex.js": 417,
	"./container/seller_application_form/SellerApplicationFormNew": 418,
	"./container/seller_application_form/SellerApplicationFormNew.js": 418,
	"./container/seller_application_form/SellerApplicationFormShow": 551,
	"./container/seller_application_form/SellerApplicationFormShow.js": 551,
	"./container/seller_application_form/components/Form": 201,
	"./container/seller_application_form/components/Form.js": 201,
	"./container/seller_application_form/components/UpdateModalForm": 202,
	"./container/seller_application_form/components/UpdateModalForm.js": 202,
	"./container/shop/BrightPearlLogin": 203,
	"./container/shop/BrightPearlLogin.js": 203,
	"./container/shop/IntegrationsContainer": 419,
	"./container/shop/IntegrationsContainer.js": 419,
	"./container/shop/SettingsContainer": 420,
	"./container/shop/SettingsContainer.js": 420,
	"./container/shop/TookanApiFormContainer": 205,
	"./container/shop/TookanApiFormContainer.js": 205,
	"./container/shop/UnimartDeliveryLogin": 207,
	"./container/shop/UnimartDeliveryLogin.js": 207,
	"./container/shop/Webhooks": 204,
	"./container/shop/Webhooks.js": 204,
	"./container/transfer/TransferFormContainer": 421,
	"./container/transfer/TransferFormContainer.jsx": 421,
	"./container/transfer/TransferIndexContainer": 422,
	"./container/transfer/TransferIndexContainer.jsx": 422,
	"./container/transfer/TransferLegacyInformation": 423,
	"./container/transfer/TransferLegacyInformation.js": 423,
	"./container/transfer/TransferPayments": 424,
	"./container/transfer/TransferPayments.jsx": 424,
	"./container/user/ForgotPasswordForm": 425,
	"./container/user/ForgotPasswordForm.jsx": 425,
	"./container/user/LoginForm": 426,
	"./container/user/LoginForm.jsx": 426,
	"./container/user/ResetPasswordForm": 427,
	"./container/user/ResetPasswordForm.jsx": 427,
	"./container/user/UserFormWrapper": 552,
	"./container/user/UserFormWrapper.jsx": 552,
	"./container/user/UserInvitationEdit": 428,
	"./container/user/UserInvitationEdit.js": 428,
	"./container/user/UserSellerFormWrapper": 429,
	"./container/user/UserSellerFormWrapper.jsx": 429,
	"./container/user/UsersIndexWrapper": 430,
	"./container/user/UsersIndexWrapper.jsx": 430,
	"./container/warranty/WarrantyFormWrapper": 431,
	"./container/warranty/WarrantyFormWrapper.jsx": 431,
	"./container/warranty/WarrantyIndexWrapper": 432,
	"./container/warranty/WarrantyIndexWrapper.jsx": 432,
	"./presentational": 4,
	"./presentational/": 4,
	"./presentational/AppLabel": 103,
	"./presentational/AppLabel.js": 103,
	"./presentational/AutocompleteSearch": 25,
	"./presentational/AutocompleteSearch.js": 25,
	"./presentational/BasicTextField": 18,
	"./presentational/BasicTextField.jsx": 18,
	"./presentational/CkeditorInput": 186,
	"./presentational/CkeditorInput.js": 186,
	"./presentational/DateActionList": 106,
	"./presentational/DateActionList.js": 106,
	"./presentational/DatePicker": 99,
	"./presentational/DatePicker.jsx": 99,
	"./presentational/FileDropZone": 156,
	"./presentational/FileDropZone.jsx": 156,
	"./presentational/ImageDropZone": 60,
	"./presentational/ImageDropZone.js": 60,
	"./presentational/ImagePreview": 185,
	"./presentational/ImagePreview.jsx": 185,
	"./presentational/ImageStackItem": 98,
	"./presentational/ImageStackItem.js": 98,
	"./presentational/ImageThumb": 433,
	"./presentational/ImageThumb.jsx": 433,
	"./presentational/ItemLink": 34,
	"./presentational/ItemLink.js": 34,
	"./presentational/ProductDropdownSearch": 188,
	"./presentational/ProductDropdownSearch.jsx": 188,
	"./presentational/QuantityProgress": 97,
	"./presentational/QuantityProgress.jsx": 97,
	"./presentational/ResourceTableBody": 19,
	"./presentational/ResourceTableBody.js": 19,
	"./presentational/ResourceTableHeaders": 21,
	"./presentational/ResourceTableHeaders.js": 21,
	"./presentational/SkeletonPageGeneric": 187,
	"./presentational/SkeletonPageGeneric.js": 187,
	"./presentational/StatusLabel": 259,
	"./presentational/StatusLabel.jsx": 259,
	"./presentational/TagsInput": 157,
	"./presentational/TagsInput.jsx": 157,
	"./presentational/TagsInputA": 158,
	"./presentational/TagsInputA.jsx": 158,
	"./presentational/dashboard/AdminDashboard": 434,
	"./presentational/dashboard/AdminDashboard.jsx": 434,
	"./presentational/dashboard/KpiDashboard": 435,
	"./presentational/dashboard/KpiDashboard.jsx": 435,
	"./presentational/dashboard/OrdersCounter": 436,
	"./presentational/dashboard/OrdersCounter.js": 436,
	"./presentational/dashboard/SellerDashboard": 437,
	"./presentational/dashboard/SellerDashboard.jsx": 437,
	"./presentational/dashboard/WelcomeDashboard": 538,
	"./presentational/dashboard/WelcomeDashboard.jsx": 538,
	"./presentational/dashboard/components/GeneralStatsCard": 53,
	"./presentational/dashboard/components/GeneralStatsCard.js": 53,
	"./presentational/dashboard/components/SaleReportOverview": 218,
	"./presentational/dashboard/components/SaleReportOverview.js": 218,
	"./presentational/dashboard/components/SaleReportStats": 217,
	"./presentational/dashboard/components/SaleReportStats.js": 217,
	"./presentational/dashboard/components/SalesLineChart": 219,
	"./presentational/dashboard/components/SalesLineChart.js": 219,
	"./presentational/dashboard/components/SellerStats": 216,
	"./presentational/dashboard/components/SellerStats.jsx": 216,
	"./presentational/dashboard/components/SoldItemStats": 107,
	"./presentational/dashboard/components/SoldItemStats.js": 107,
	"./presentational/dispatch_control/DispatchControlForm": 190,
	"./presentational/dispatch_control/DispatchControlForm.jsx": 190,
	"./presentational/dispatch_control/DispatchControlOrders": 100,
	"./presentational/dispatch_control/DispatchControlOrders.jsx": 100,
	"./presentational/goods_moved_log/ReturnsByOrder": 269,
	"./presentational/goods_moved_log/ReturnsByOrder.js": 269,
	"./presentational/goods_moved_log/ReturnsByTransfer": 270,
	"./presentational/goods_moved_log/ReturnsByTransfer.js": 270,
	"./presentational/index": 4,
	"./presentational/index.js": 4,
	"./presentational/information/CTABanner": 125,
	"./presentational/information/CTABanner.js": 125,
	"./presentational/information/SimpleToast": 539,
	"./presentational/information/SimpleToast.js": 539,
	"./presentational/order_supply/InformativeModal": 191,
	"./presentational/order_supply/InformativeModal.js": 191,
	"./presentational/order_supply/OrderSupplyConfirmationModal": 540,
	"./presentational/order_supply/OrderSupplyConfirmationModal.jsx": 540,
	"./presentational/order_supply/OrderSupplyRequestModal": 541,
	"./presentational/order_supply/OrderSupplyRequestModal.jsx": 541,
	"./presentational/order_supply/OrderSupplyRequestTable": 542,
	"./presentational/order_supply/OrderSupplyRequestTable.jsx": 542,
	"./presentational/product/APBChangeModal": 264,
	"./presentational/product/APBChangeModal.js": 264,
	"./presentational/product/ProductForm": 180,
	"./presentational/product/ProductForm.jsx": 180,
	"./presentational/product/ProductFormVariants": 183,
	"./presentational/product/ProductFormVariants.jsx": 183,
	"./presentational/product/ProductShow": 159,
	"./presentational/product/ProductShow.jsx": 159,
	"./presentational/product/ProductsTable": 154,
	"./presentational/product/ProductsTable.jsx": 154,
	"./presentational/product/VariantForm": 222,
	"./presentational/product/VariantForm.jsx": 222,
	"./presentational/product/VariantGoodsLogItem": 543,
	"./presentational/product/VariantGoodsLogItem.js": 543,
	"./presentational/product/VariantModal": 184,
	"./presentational/product/VariantModal.jsx": 184,
	"./presentational/sale_report/SalesBySeller": 194,
	"./presentational/sale_report/SalesBySeller.js": 194,
	"./presentational/sale_report/SalesByTransfers": 193,
	"./presentational/sale_report/SalesByTransfers.js": 193,
	"./presentational/section/AppLinkItem": 126,
	"./presentational/section/AppLinkItem.js": 126,
	"./presentational/section/AppLinkModal": 200,
	"./presentational/section/AppLinkModal.js": 200,
	"./presentational/section/AppLinksForm": 105,
	"./presentational/section/AppLinksForm.js": 105,
	"./presentational/section/BannerB2BForm": 198,
	"./presentational/section/BannerB2BForm.js": 198,
	"./presentational/section/BannerFormModal": 196,
	"./presentational/section/BannerFormModal.js": 196,
	"./presentational/section/BannerGeneralForm": 197,
	"./presentational/section/BannerGeneralForm.js": 197,
	"./presentational/section/BannerListForm": 199,
	"./presentational/section/BannerListForm.js": 199,
	"./presentational/section/SectionForm": 104,
	"./presentational/section/SectionForm.js": 104,
	"./presentational/seller/SellerForm": 152,
	"./presentational/seller/SellerForm.jsx": 152,
	"./presentational/seller/SellerFormProfile": 153,
	"./presentational/seller/SellerFormProfile.jsx": 153,
	"./presentational/seller/SellerShow": 544,
	"./presentational/seller/SellerShow.jsx": 544,
	"./presentational/shared/GeneralModal": 545,
	"./presentational/shared/GeneralModal.js": 545,
	"./presentational/shared/ImportFileModal": 102,
	"./presentational/shared/ImportFileModal.js": 102,
	"./presentational/shop/SettingsForm": 208,
	"./presentational/shop/SettingsForm.js": 208,
	"./presentational/shop/TookanApiForm": 206,
	"./presentational/shop/TookanApiForm.js": 206,
	"./presentational/shop/Webhooks": 209,
	"./presentational/shop/Webhooks.js": 209,
	"./presentational/transfer/TransferForm": 160,
	"./presentational/transfer/TransferForm.jsx": 160,
	"./presentational/transfer/TransferShippingModal": 161,
	"./presentational/transfer/TransferShippingModal.jsx": 161,
	"./presentational/transfer/TransferShow": 271,
	"./presentational/transfer/TransferShow.jsx": 271,
	"./presentational/transfer/components/LogItem": 215,
	"./presentational/transfer/components/LogItem.jsx": 215,
	"./presentational/transfer/components/LogsList": 214,
	"./presentational/transfer/components/LogsList.jsx": 214,
	"./presentational/transfer/components/TransferFormItems": 189,
	"./presentational/transfer/components/TransferFormItems.js": 189,
	"./presentational/transfer/components/TransferGeneralInfo": 210,
	"./presentational/transfer/components/TransferGeneralInfo.js": 210,
	"./presentational/transfer/components/TransferItemFooter": 213,
	"./presentational/transfer/components/TransferItemFooter.jsx": 213,
	"./presentational/transfer/components/TransferItemForShow": 211,
	"./presentational/transfer/components/TransferItemForShow.jsx": 211,
	"./presentational/transfer/components/TransferItemHeaders": 212,
	"./presentational/transfer/components/TransferItemHeaders.jsx": 212,
	"./presentational/user/UserForm": 150,
	"./presentational/user/UserForm.jsx": 150,
	"./presentational/user/UserSellerForm": 151,
	"./presentational/user/UserSellerForm.jsx": 151,
	"./presentational/user/UserShow": 546,
	"./presentational/user/UserShow.jsx": 546,
	"./presentational/warranty/WarrantyForm": 148,
	"./presentational/warranty/WarrantyForm.jsx": 148,
	"./presentational/warranty/WarrantyShow": 547,
	"./presentational/warranty/WarrantyShow.jsx": 547,
	"./shared/ui/PolarisRecordsTable": 101,
	"./shared/ui/PolarisRecordsTable.js": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 585;